import { RootState } from '@store';
import { selectVehicleDetails } from './vehicleDetailsSelectors';

export const selectIsUsedCar = (state: RootState): boolean => {
  return selectVehicleDetails(state)?.isUsedCar;
};
